import { useTranslation } from '@dukanti/shared';
import type { StoreOrderSortBy } from '@dukanti/shared';
import { ChevronDown } from 'lucide-react';

export interface OrdersSortDropdownProps {
  readonly value: StoreOrderSortBy;
  readonly onChange: (sortBy: StoreOrderSortBy) => void;
}

export function OrdersSortDropdown({
  value,
  onChange,
}: OrdersSortDropdownProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <span className="text-muted-foreground text-sm">{t('admin.orders.sort.visibleLabel')}</span>
      <div className="relative">
        <select
          data-testid="orders-sort-dropdown"
          aria-label={t('admin.orders.sort.label')}
          value={value}
          onChange={(e) => onChange(e.target.value as StoreOrderSortBy)}
          className="rounded-btn border-input bg-card text-foreground hover:bg-admin-surface-muted focus:ring-admin-lime/20 flex cursor-pointer appearance-none items-center gap-2 border bg-none px-4 py-2 pe-10 text-start text-base font-medium transition-colors [-moz-appearance:none] [-webkit-appearance:none] focus:outline-none focus:ring-2 md:text-sm"
        >
          <option value="created_at_desc">{t('admin.orders.sort.createdAtDesc')}</option>
          <option value="created_at_asc">{t('admin.orders.sort.createdAtAsc')}</option>
          <option value="total_desc">{t('admin.orders.sort.totalDesc')}</option>
          <option value="total_asc">{t('admin.orders.sort.totalAsc')}</option>
        </select>
        <ChevronDown
          className="text-muted-foreground pointer-events-none absolute end-3 top-1/2 size-4 -translate-y-1/2"
          aria-hidden
        />
      </div>
    </div>
  );
}
